import createMuiTheme, {
  Theme,
  ThemeOptions,
} from '@material-ui/core/styles/createMuiTheme';
import {
  Palette,
  PaletteOptions,
} from '@material-ui/core/styles/createPalette';
import {
  Spacing,
  SpacingOptions as MUISpacingOptions,
} from '@material-ui/core/styles/spacing';
import createMaxWidths, { MaxWidths } from './createMaxWidths';
import * as CustomColors from './colors';

declare module '@material-ui/core/styles/spacing' {
  interface Spacing {
    formRow: number;
  }

  interface MUISpacingOptions {
    formRow?: number;
  }
}
declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    warning: PaletteColor;
    ok: PaletteColor;
    mint: PaletteColor;
    white: PaletteColor;
    darkBlue: PaletteColor;
  }

  // `createMuiTheme`'s parameter, used to customize/extend theme
  interface PaletteOptions {
    warning: PaletteColor;
    ok: PaletteColor;
    mint: PaletteColor;
    white: PaletteColor;
    darkBlue: PaletteColor;
  }
}

declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    maxWidths: MaxWidths;
    palette: Palette;
    spacing: Spacing;
  }

  // `createMuiTheme`'s parameter, used to customize/extend theme
  interface ThemeOptions {
    maxWidths?: MaxWidths;
    palette?: PaletteOptions;
    spacing?: MUISpacingOptions;
  }
}

interface Options extends ThemeOptions {
  // we want to make pallete a not optional property
  palette?: PaletteOptions;
}

export function createMyTheme(options: Options): Theme {
  return createMuiTheme({
    maxWidths: createMaxWidths(),
    ...options,
    palette: {
      primary: CustomColors.primary,
      secondary: CustomColors.secondary,
      error: CustomColors.negative,
      grey: CustomColors.grey,
      ok: CustomColors.positive,
      warning: CustomColors.warning,
      mint: CustomColors.mint,
      white: CustomColors.white,
      darkBlue: CustomColors.darkBlue,
      ...options.palette,
    },
    typography: {
      fontFamily: "'Source Sans Pro', 'Helvetica', 'Arial', 'sans-serif'",
      fontSize: 14,
      ...options.typography,
    },
    spacing: {
      formRow: 1.4,
      ...options.spacing,
    },
  });
}

const theme = createMyTheme({});

export default theme;
